import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = () =>
  ({
    label: {
      display: "flex",
      alignItems: "center",
      margin: "2px 0 4px 0",
      color: colors.gray700,
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "18px",
      letterSpacing: "0.1px"
    },
    titleLeft: {
      display: "flex",
      alignItems: "center"
    },
    titleTooltip: {
      display: "flex",
      alignItems: "center",
      marginLeft: "4px",

      "& > svg": {
        fontSize: "16px",
        color: colors.blue700
      }
    }
  }) as CSSObject;
